import React, { useCallback, useMemo, useRef, useState } from 'react';

import chevronTokens from '@amzn/meridian-tokens/base/icon/chevron-right-small';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Menu, { MenuItem } from '@amzn/meridian/menu';
import Row from '@amzn/meridian/row';

import { ITablePicker } from 'src/components/CompareContracts/TablePickers/table-picker-props';
import { createLookup, createStack } from 'src/components/CompareContracts/utils/comparison-extractor';

export const BreadcrumbTablePicker: React.FC<ITablePicker> = (props: ITablePicker) => {
    const lookup = useMemo(() => createLookup(props.comparison), [props.comparison]);
    const stack = useMemo(() => createStack(lookup, props.table), [lookup, props.table]);
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useCallback(
        (table: string) => {
            setMenuOpen(false);
            props.setTable(table);
        },
        [setMenuOpen, props.setTable]
    );
    const buttonRef = useRef();
    const options = lookup[props.table]?.children ?? [];
    const drilldown = (
        <>
            <Button ref={buttonRef} onClick={() => setMenuOpen(true)} type={'secondary'} size={'small'}>
                <Icon tokens={chevronTokens} />
                Select nested table
            </Button>
            <Menu open={menuOpen} onClose={() => setMenuOpen(false)} position={'end'} anchorNode={buttonRef.current}>
                {options.map((option) => (
                    <MenuItem key={option} onClick={() => navigate(option)}>
                        {option}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
    return (
        <Row>
            <BreadcrumbGroup>
                {stack.map((table) => (
                    <Breadcrumb key={table} onClick={() => props.setTable(table)}>
                        {table}
                    </Breadcrumb>
                ))}
            </BreadcrumbGroup>
            {options.length > 0 && drilldown}
        </Row>
    );
};
